export default __webpack_public_path__ + "a46cb954fc32306555b7e56834b4714a.svg";